<div class="margin-bottom" [@filtersState]="visible ? 'visible' : 'hidden'">
  <lms-dynamic-form
    #filtersForm
    [questions]="filtersQuestions"
    [action]="'search.filter'"
    [options]="{ hideSubmit: true, showSpinnerUponSubmitting: false }"
    (submit)="applyFilters($event)"
  >
    <gl-button
      *ngIf="!hideClose"
      color-secondary
      class="margin-right"
      [text]="'actions.close' | translate"
      (onClick)="toggleVisible()"
      form-actions-before
    ></gl-button>
    <gl-button
      color-primary
      [text]="options.submitLabel || 'actions.filter' | translate"
      [disabled]="filtersForm.form.invalid"
      (onClick)="filtersForm.onSubmit()"
      form-actions-before
    >
    </gl-button>
  </lms-dynamic-form>
</div>
